<p-card class="p-3">
  <ng-template #header
    ><div class="text-start">
      <i class="fa-solid fa-microchip mr-3"></i>Gen2 IO Extenders
    </div></ng-template
  ><p-table
    showGridlines="true"
    stripedRows
    size="small"
    [value]="gen2Extenders().extenders"
    [columns]="columns"
  >
    <ng-template #header let-columns>
      <tr>
        @for (column of columns; track column; let idx = $index) {
          @if (idx == 0) {
            <th class="w-2">
              <div class="text-center">
                <span class="hidden lg:inline">{{ column }}</span>
              </div>
            </th>
          } @else if (idx == 1) {
            <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16">
              <div class="text-center">
                <span class="hidden lg:inline">{{ column }}</span>
              </div>
            </th>
          } @else {
            <th>{{ column }}</th>
          }
        }
      </tr>
    </ng-template>
    <ng-template #body let-field let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="text-center">{{ field.index }}</div>
        </td>

        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(
              customFunctions.getDeviceStatus(field.available, field.error)
            )
          "
        >
          <div class="text-center">
            <i
              [class]="
                iconsStyles.getDeviceStatusIcon(
                  customFunctions.getDeviceStatus(field.available, field.error)
                )
              "
              class="lg:mr-2"
            ></i
            ><span class="hidden lg:inline">{{
              customFunctions.getDeviceStatus(field.available, field.error)
            }}</span>
          </div>
        </td>

        @for (
          i of [].constructor(gen2Extenders().digitalInputsAmount);
          track idx;
          let idx = $index
        ) {
          <td>
            <div class="text-center">
              <i
                class="text-xl mt-1"
                [class]="
                  customFunctions.bitwiseIO(field.digitalInputs, idx + 1)
                    ? 'fa-solid fa-toggle-on'
                    : 'fa-solid fa-toggle-off'
                "
              ></i>
            </div>
          </td>
        }
        @for (
          i of [].constructor(gen2Extenders().digitalOutputsAmount);
          track idx;
          let idx = $index
        ) {
          <td>
            <div class="text-center">
              <i
                class="text-xl mt-1"
                [class]="
                  customFunctions.bitwiseIO(field.digitalOutputs, idx + 1)
                    ? 'fa-solid fa-toggle-on'
                    : 'fa-solid fa-toggle-off'
                "
              ></i>
            </div>
          </td>
        }
        @if (field.analogCurrentOutput[0]) {
          <td>{{ field.analogCurrentOutput[0][1] }} V</td>
        } @else {
          <td>0 V</td>
        }
        @if (field.analogVoltageOutput[0]) {
          <td>{{ field.analogVoltageOutput[0][1] }} mA</td>
        } @else {
          <td>0 mA</td>
        }
        @if (field.analogVoltageInput[0]) {
          <td>{{ field.analogVoltageInput[0][1] }} V</td>
        } @else {
          <td>0 V</td>
        }
        @if (field.analogCurrentInput[0]) {
          <td>{{ field.analogCurrentInput[0][1] }} mA</td>
        } @else {
          <td>0 mA</td>
        }
        <td>{{ field.lastUpdate | date: "dd-MM-yyyy, HH:mm" }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
